<div id="layout-wrapper">
  <app-horizontaltopbar></app-horizontaltopbar>
  <div class="main-content">
    <div class="page-content">
      <!-- Banner Global de Alerta de Suscripción -->
      <app-subscription-alert-banner></app-subscription-alert-banner>

      <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb>
      @if (validatorsService.id_sucursal() && !validatorsService.reload()) {
      <router-outlet></router-outlet>
      }
      <div class="card flex justify-content-center animated animate fadeInDown">
        <p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }" />
      </div>
    </div>
  </div>
  <app-footer></app-footer>
  <app-rightsidebar></app-rightsidebar>
  <app-modal-refresh-token></app-modal-refresh-token>
</div>